@if (pictures$ | async; as pictures) {
  <ng-image-slider
    [animationSpeed]="0.3"
    [images]="pictures"
    [imageSize]="{ width: 120, height: 120, space: 3 }"
  ></ng-image-slider>
}
